"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var loginApiFactory_ec_1 = __importDefault(require("./loginApiFactory.ec"));
exports.default = loginApiFactory_ec_1.default;
//# sourceMappingURL=loginApiFactory.js.map